module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-content', [_c('p', [_vm._v("\n        セット名（英語）、セット名（日本語）、作成者、フィガーを入力してください。「*(アスタリスク)」が付いている項目は必須項目です。\n      ")]), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.setNameError),
      expression: "!setNameError"
    }],
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("セット名（英語）")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.setName),
      callback: function($$v) {
        _vm.setName = $$v
      },
      expression: "setName"
    }
  })], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.setNameError),
      expression: "setNameError"
    }],
    staticClass: "md-input-invalid",
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("セット名（英語）")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.setName),
      callback: function($$v) {
        _vm.setName = $$v
      },
      expression: "setName"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error",
    model: {
      value: (_vm.setNameError),
      callback: function($$v) {
        _vm.setNameError = $$v
      },
      expression: "setNameError"
    }
  }, [_vm._v(_vm._s(_vm.setNameError))])], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.setNameJPError),
      expression: "!setNameJPError"
    }],
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("セット名（日本語）")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.setNameJP),
      callback: function($$v) {
        _vm.setNameJP = $$v
      },
      expression: "setNameJP"
    }
  })], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.setNameJPError),
      expression: "setNameJPError"
    }],
    staticClass: "md-input-invalid",
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("セット名（日本語）")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.setNameJP),
      callback: function($$v) {
        _vm.setNameJP = $$v
      },
      expression: "setNameJP"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error",
    model: {
      value: (_vm.setNameJPError),
      callback: function($$v) {
        _vm.setNameJPError = $$v
      },
      expression: "setNameJPError"
    }
  }, [_vm._v(_vm._s(_vm.setNameJPError))])], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editerNameError),
      expression: "!editerNameError"
    }],
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("作成者")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.editerName),
      callback: function($$v) {
        _vm.editerName = $$v
      },
      expression: "editerName"
    }
  })], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editerNameError),
      expression: "editerNameError"
    }],
    staticClass: "md-input-invalid",
    attrs: {
      "md-clearable": ""
    }
  }, [_c('label', [_vm._v("作成者")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.editerName),
      callback: function($$v) {
        _vm.editerName = $$v
      },
      expression: "editerName"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "md-error",
    model: {
      value: (_vm.editerNameError),
      callback: function($$v) {
        _vm.editerNameError = $$v
      },
      expression: "editerNameError"
    }
  }, [_vm._v(_vm._s(_vm.editerNameError))])], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("セットの説明")]), _vm._v(" "), _c('md-textarea', {
    model: {
      value: (_vm.notices),
      callback: function($$v) {
        _vm.notices = $$v
      },
      expression: "notices"
    }
  })], 1), _vm._v(" "), _vm._l((_vm.figures), function(figure, figureIndex) {
    return _c('md-card', {
      key: figureIndex,
      staticClass: "figure"
    }, [_c('md-card-header', [_c('div', {
      staticClass: "md-title"
    }, [_vm._v("Figure #" + _vm._s(figure.order))]), _vm._v(" "), _c('md-select', {
      attrs: {
        "placeholder": figure.rythmn
      },
      model: {
        value: (figure.rythmn),
        callback: function($$v) {
          _vm.$set(figure, "rythmn", $$v)
        },
        expression: "figure.rythmn"
      }
    }, _vm._l((['Hornpipe', 'Jig', 'Polka', 'Quadrilles', 'Reel', 'Slide', 'Up Jig', 'Waltz']), function(rythmn, rythmnIndex) {
      return _c('md-option', {
        key: rythmnIndex,
        attrs: {
          "value": "rythmn"
        }
      }, [_vm._v(_vm._s(rythmn))])
    })), _vm._v(" "), _c('md-input-container', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.editerNameError),
        expression: "!editerNameError"
      }],
      attrs: {
        "md-clearable": ""
      }
    }, [_c('label', [_vm._v("フィガーの概要")]), _vm._v(" "), _c('md-input', {
      attrs: {
        "required": ""
      },
      model: {
        value: (figure.description),
        callback: function($$v) {
          _vm.$set(figure, "description", $$v)
        },
        expression: "figure.description"
      }
    })], 1)], 1), _vm._v(" "), _c('md-card-content', [_c('md-list', {
      staticClass: "figure-details"
    }, _vm._l((figure.movements), function(movement, index) {
      return (movement.bar !== '') ? _c('md-list-item', {
        key: index,
        staticClass: "movement",
        class: movement.type,
        on: {
          "click": function($event) {
            _vm.openMovementDialog('editMovementDialog', figureIndex, _vm.movementIndex, movement)
          }
        }
      }, [(movement.type === 'call-repeat') ? _c('span', {
        key: "callRepeatPart",
        staticClass: "bar",
        class: movement.type
      }, [_c('md-chip', {
        staticClass: "md-primary"
      }, [_vm._v(_vm._s(movement.bar))])], 1) : (movement.type === 'repeat') ? _c('span', {
        key: "repeatPart",
        staticClass: "bar",
        class: movement.type
      }, [_c('md-chip', {
        staticClass: "md-primary"
      }, [_vm._v(_vm._s(movement.bar))])], 1) : (movement.type === 'nested-repeat') ? _c('span', {
        key: "nestedRepeatPart",
        staticClass: "bar",
        class: movement.type
      }, [_c('md-chip', {
        staticClass: "md-accent"
      }, [_vm._v(_vm._s(movement.bar))])], 1) : (movement.type === 'call-nested-repeat') ? _c('span', {
        key: "callNestedRepeatPart",
        staticClass: "bar",
        class: movement.type
      }, [_c('md-chip', {
        staticClass: "md-accent"
      }, [_vm._v(_vm._s(movement.bar))])], 1) : _c('span', {
        key: "noramlPart",
        staticClass: "bar",
        class: movement.type
      }, [_c('md-chip', {
        staticClass: "md-default"
      }, [_vm._v(_vm._s(movement.bar))])], 1), _vm._v(" "), _c('div', {
        staticClass: "md-list-text-container"
      }, [_c('span', [_c('md-button', {
        staticClass: "summary",
        on: {
          "click": function($event) {
            _vm.openMovementDialog('editMovementDialog', figureIndex, _vm.movementIndex, movement)
          }
        }
      }, [_vm._v("\n                    " + _vm._s(movement.summary)), _c('i', {
        staticClass: "material-icons"
      }, [_vm._v("edit")]), _c('div', {
        staticClass: "clear"
      })])], 1), _vm._v(" "), (movement.subject) ? _c('span', {
        key: "movementWithSubject"
      }, [_vm._v("\n                  " + _vm._s(movement.subject) + "\n                ")]) : _vm._e()]), _vm._v(" "), (index !== figure.movements.length - 1) ? _c('md-divider') : _vm._e()], 1) : _vm._e()
    })), _vm._v(" "), _c('md-button', {
      staticClass: "md-raised md-primary",
      on: {
        "click": function($event) {}
      }
    }, [_vm._v("動きを追加する")])], 1)], 1)
  }), _vm._v(" "), _c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {}
    }
  }, [_vm._v("フィガーを追加する")])], 2), _vm._v(" "), _c('div', {
    staticClass: "controller"
  }, [_c('md-button', {
    staticClass: "md-raised md-primary",
    on: {
      "click": function($event) {
        _vm.setEvent('dialog5')
      }
    }
  }, [_vm._v("更新する")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "deleteSetDialog",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-title', [_vm._v("セットを削除します")]), _vm._v(" "), _c('md-dialog-content', [_vm._v("\n      この操作は取り消せません。" + _vm._s(_vm.setName) + " Setを削除しますか？\n\n    ")]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.cancelDialog('deleteSetDialog')
      }
    }
  }, [_vm._v("キャンセル")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.deleteSet('deleteSetDialog')
      }
    }
  }, [_vm._v("削除する")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "editMovementDialog",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-title', [_vm._v("フィガーに動きを追加します")]), _vm._v(" "), (_vm.movement) ? _c('md-dialog-content', [_c('md-input-container', [_c('label', {
    attrs: {
      "for": "bar"
    }
  }, [_vm._v("小節数")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "placeholder": String(_vm.movement.bar)
    },
    model: {
      value: (_vm.figures[_vm.figureIndex].movements[_vm.movementIndex].bar),
      callback: function($$v) {
        _vm.$set(_vm.figures[_vm.figureIndex].movements[_vm.movementIndex], "bar", $$v)
      },
      expression: "figures[figureIndex].movements[movementIndex].bar"
    }
  }, _vm._l(([8, 16, 24, 32, 40, 48, 56, 64, 72, 80, 88, 96, 104, 112, 120, 128, 136, 144, 152, 160]), function(bar, barIndex) {
    return _c('md-option', {
      key: barIndex,
      attrs: {
        "value": "bar"
      }
    }, [_vm._v(_vm._s(bar))])
  }))], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editerNameError),
      expression: "!editerNameError"
    }]
  }, [_c('label', [_vm._v("要約（Lead Aroundなど）")]), _vm._v(" "), _c('md-input', {
    attrs: {
      "required": ""
    },
    model: {
      value: (_vm.figures[_vm.figureIndex].movements[_vm.movementIndex].summary),
      callback: function($$v) {
        _vm.$set(_vm.figures[_vm.figureIndex].movements[_vm.movementIndex], "summary", $$v)
      },
      expression: "figures[figureIndex].movements[movementIndex].summary"
    }
  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "movie"
    }
  }, [_vm._v("動きをする人")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "placeholder": _vm.movement.subject,
      "name": 'subject' + _vm.movementIndex,
      "id": 'subject' + _vm.movementIndex
    },
    model: {
      value: (_vm.figures[_vm.figureIndex].movements[_vm.movementIndex].subject),
      callback: function($$v) {
        _vm.$set(_vm.figures[_vm.figureIndex].movements[_vm.movementIndex], "subject", $$v)
      },
      expression: "figures[figureIndex].movements[movementIndex].subject"
    }
  }, _vm._l((['Everyone', 'Tops', 'Sides', '1st Top', '2nd Top', '1st Side', '2nd Side', '1st Gent & opposite Lady']), function(subject, subjectIndex) {
    return _c('md-option', {
      key: subjectIndex,
      attrs: {
        "value": "subject"
      }
    }, [_vm._v(_vm._s(subject))])
  }))], 1), _vm._v(" "), _c('md-input-container', [_c('label', {
    attrs: {
      "for": "movie"
    }
  }, [_vm._v("繰り返し")]), _vm._v(" "), _c('md-select', {
    attrs: {
      "placeholder": _vm.しない,
      "name": 'type' + _vm.movementIndex,
      "id": 'type' + _vm.movementIndex
    },
    model: {
      value: (_vm.figures[_vm.figureIndex].movements[_vm.movementIndex].type),
      callback: function($$v) {
        _vm.$set(_vm.figures[_vm.figureIndex].movements[_vm.movementIndex], "type", $$v)
      },
      expression: "figures[figureIndex].movements[movementIndex].type"
    }
  }, _vm._l((['しない', 'Repeat']), function(type, typeIndex) {
    return _c('md-option', {
      key: typeIndex,
      attrs: {
        "value": "type"
      }
    }, [_vm._v(_vm._s(type))])
  }))], 1), _vm._v(" "), _c('md-input-container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editerNameError),
      expression: "!editerNameError"
    }]
  }, [_c('label', [_vm._v("動きの解説（オプション）")]), _vm._v(" "), _c('md-input', {
    model: {
      value: (_vm.figures[_vm.figureIndex].movements[_vm.movementIndex].caption),
      callback: function($$v) {
        _vm.$set(_vm.figures[_vm.figureIndex].movements[_vm.movementIndex], "caption", $$v)
      },
      expression: "figures[figureIndex].movements[movementIndex].caption"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    on: {
      "click": function($event) {
        _vm.cancelDialog('deleteSetDialog')
      }
    }
  }, [_vm._v("削除する")]), _vm._v(" "), _c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": function($event) {
        _vm.deleteSet('deleteSetDialog')
      }
    }
  }, [_vm._v("作成する")])], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "dialog5",
    attrs: {
      "md-title": _vm.confirm.title,
      "md-content-html": _vm.confirm.contentHtml,
      "md-ok-text": _vm.confirm.ok,
      "md-cancel-text": _vm.confirm.cancel
    },
    on: {
      "open": _vm.onOpen,
      "close": _vm.onClose
    }
  }), _vm._v(" "), _c('form', {
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.openErrorConsole($event)
      }
    }
  }, [_c('md-snackbar', {
    ref: "snackbar",
    attrs: {
      "md-position": 'top center',
      "md-duration": 4000
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.errorMessage))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db4a0486","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditSet.vue
// module id = 344
// module chunks = 1